import PropTypes from 'prop-types';
import React from 'react';
import { ToastContainer } from 'react-toastify';

import Alert from './alert';
import Bar from './bars/bar';
import ScrollToTopBtn from './buttons/back-to-top-btn';
import JumpToContentButton from './buttons/jump-to-content-button';
import Footer from './footer';
import Header from './header/header';
import Seo from './seo';

const Framework = ({
	alert = true,
	children,
	description,
	footer = true,
	header = true,
	location,
	meta,
	robots,
	schema,
	tags,
	title,
	tracking,
	type,
}) => {
	return (
		<>
			<Seo
				description={description}
				location={location}
				meta={meta}
				robots={robots}
				schema={schema}
				tags={tags}
				title={title}
				tracking={tracking}
				type={type}
			/>
			<JumpToContentButton />
			{alert && <Alert />}
			{header && <Header />}

			{header && <Bar hasCountDown />}

			{children}
			{footer && <Footer />}
			<ScrollToTopBtn />
			<ToastContainer
				autoClose={5000}
				draggable
				hideProgressBar
				pauseOnHover
				position="top-right"
				theme="dark"
			/>
		</>
	);
};

Framework.propTypes = {
	alert: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	description: PropTypes.string,
	footer: PropTypes.bool,
	header: PropTypes.bool,
	location: PropTypes.object.isRequired,
	meta: PropTypes.array,
	robots: PropTypes.string,
	schema: PropTypes.object,
	tags: PropTypes.string,
	title: PropTypes.string.isRequired,
	tracking: PropTypes.object,
	type: PropTypes.string,
};

export default Framework;
